import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input
} from "@angular/core";

@Component({
  selector: "av-option-block",
  templateUrl: "./option.component.html",
  styleUrls: ["./option.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OptionBlockComponent {
  readonly label = input<string>(undefined);
  readonly active = input<boolean>(undefined);

  @HostBinding("class") get class() {
    return {
      active: this.active(),
    };
  }
}
